import { default as initCommonDataStore } from "../../../../lib/common/js/dataStore"
import { initAnswersUtils } from "./answersUtils"

function getInitialValues() {
  return {
    // Globals
    usePaymentsApi: true,
    token: null,
    measurementSystem: pipelineConfig.measurementSystem,
    domain: null,
    activeOffer: null,
    marketingAgreed: null,
    privacyAgreement: false,
    purchasedBasicOffer: null,
    skippedUpsellOffers: [],
    checkout: null,
    initiateCheckoutAt: null,
    isEmailStepCompleted: false,
    exitIntent: false,
    isExitIntentPopupShown: false,
    isPaymentLoading: false,
    segmentUserId: null,
    cookiePolicyBannerAccepted: null,
    isSignatureSigned: false,
    customerId: null,

    // Specific values for the series

    // Pipe form
    gender: null,
    ageRange: null,
    primaryGoal: [],
    firstName: null,
    currentBodyShape: null,
    dietFamiliarity: null,
    dailyHungerTime: null,
    breakfastTime: null,
    lunchTime: null,
    dinnerTime: null,
    mealPreparation: null,
    weeklyActivityLevel: null,
    workingHours: null,
    dailyActivityLevel: null,
    secondaryGoal: null,
    secondaryGoalMultiple: [],
    age: null,
    heightFt: null,
    heightIn: null,
    heightCm: null,
    weightKg: null,
    weightLbs: null,
    targetWeightKg: null,
    targetWeightLbs: null,
    goalPaceKg: 1,
    goalPaceLbs: 1,
    walking: null,
    sleepHours: null,
    changingEatingHabits: null,
    healthyLifestyleInterests: null,
    currentWeightLossPractices: [],
    dailyWaterIntake: null,
    supplementAndMedicationUsage: null,
    rhetoricalQuestionConfidentInClothes: null,
    rhetoricalQuestionMoreEnergy: null,
    rhetoricalQuestionDevelopHealthyHabits: null,
    rhetoricalQuestionFeelCalmer: null,
    rhetoricalQuestionStrongerBody: null,
    healthConditions: [],
    email: null,
  }
}

// Define data values to be used in this specific pipe series
// and feed them to the basic data store creator fn, which is placed
// in the `lib` under current pipe brand folder.
const dataStore = {
  ...initCommonDataStore({
    getInitialValues,
  }),

  // All series-specific props and methods can de added or overwritten below:
  // isMetric() { },
}

// Series-specific namespaced helpers for conditional
// UI rendering based on previous answers.
// Why not initiated in common: we can't guarantee that
// different series will have same data values names and logic
dataStore.answersUtils = initAnswersUtils(dataStore)

export default dataStore
